import React, { useState, useEffect } from "react";
import {
    fetchEventNewsSpeech,
    publishEventNewsSpeech,
} from "../../services/event_news_speech";

const PostItem = ({ post, onPublish }) => {
    const isPublished = post.is_published;
    const publishButtonStyle = isPublished ? "bg-green-500" : "bg-red-500";
    const publishButtonText = isPublished ? "Published" : "Publish";

    const handlePublish = async () => {
        onPublish(post.id);
        await publishEventNewsSpeech(post.id);
    };

    const title =
        post.title.length > 20 ? `${post.title.slice(0, 20)}...` : post.title;

    return (
        <div className="border-b border-gray-300 py-6 flex justify-between items-start">
            <div className="flex-1 pr-4">
                <h3 className="text-xl font-semibold">{title}</h3>
                <p className="text-sm text-gray-600">
                    {new Date(post.event_date).toLocaleDateString()}
                </p>
                <p className="mt-2 text-gray-500" dangerouslySetInnerHTML={{ __html: post.description }}></p>
                <p
                    className={`mt-2 ${
                        post.type === "news"
                            ? "text-green-500"
                            : post.type === "event"
                            ? "text-blue-500"
                            : "text-red-500"
                    }`}
                >
                    {post.type}
                </p>
            </div>
            <button
                className={`${publishButtonStyle} text-white px-4 py-2 rounded`}
                onClick={handlePublish}
            >
                {publishButtonText}
            </button>
        </div>
    );
};

const AllNewsEvents = ({ posts, onPublish }) => {
    return (
        <div className="max-w-4xl mx-auto mt-10 p-6 rounded-xl shadow-lg">
            {posts.length > 0 ? (
                posts.reverse().map((post) => (
                    <PostItem key={post.id} post={post} onPublish={onPublish} />
                ))
            ) : (
                <p className="text-center text-gray-500">No events or news found.</p>
            )}
        </div>
    );
};

export default function AllNewsEventsData() {
    const [fetchedData, setFetchedData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [publishing, setPublishing] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const data = await fetchEventNewsSpeech();
            setFetchedData(data.data || []);
            setLoading(false);
        };
        fetchData();
    }, []);

    const handlePublish = async (id) => {
        setPublishing(id);
        const updatedPosts = fetchedData.map((post) =>
            post.id === id ? { ...post, is_published: !post.is_published } : post
        );
        setFetchedData(updatedPosts);
        await publishEventNewsSpeech(id);
        setPublishing(null);
    };

    if (loading) {
        return <p className="text-center mt-10 text-gray-500">Loading...</p>;
    }

    return (
        <div className="relative">
            {publishing && (
                <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center">
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500"></div>
                </div>
            )}
            <AllNewsEvents posts={fetchedData} onPublish={handlePublish} />
        </div>
    );
}